import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClient, HttpClientModule } from '@angular/common/http';

import { InsurancesComponent } from './insurances.component';
import { InsurancesFiltersComponent } from './insurances-filters/insurances-filters.component';

import { ListService } from '../list.service';

import { AngularMaterialModule } from '../angular-material.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    AngularMaterialModule
  ],
  providers: [
    InsurancesFiltersComponent,
    ListService
  ],
  declarations: [
    InsurancesComponent,
    InsurancesFiltersComponent
  ],
  exports: [
    InsurancesComponent
  ]
})

export class InsurancesModule { }
